/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dependencies } from '@configurations/dependencies/dependencies';
import { UnitRate } from '@scenario/models/unit-rate.model';
import { Action } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import {
  retrieveUnitRatesFailure,
  retrieveUnitRatesSuccess,
} from '@store/scenario/unit-rates/unit-rates-slice';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

export const retrieveUnitRatesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('unitRates/retrieveUnitRates'),
    concatMap((_action: Action) =>
      from(dependencies.unitRatesGateway.retrieveAll()).pipe(
        map((unitRates: UnitRate[]) => retrieveUnitRatesSuccess(unitRates)),
        catchError(_e => {
          return of(retrieveUnitRatesFailure('Fail to retrieve unit rates'));
        }),
      ),
    ),
  );
